(function () {
  var TARGET_VARIANT = '55026179309873';
  var SOAP_VARIANT = '55264654229809';
  var PAID_ROLE = 'paid';
  var FREE_ROLE = 'free';
  var busy = false;

  function rootUrl(path) {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return root + path;
  }

  function requestJson(method, path, body) {
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open(method, rootUrl(path), true);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      if (body !== undefined) request.setRequestHeader('Content-Type', 'application/json');
      request.onload = function () {
        if (request.status < 200 || request.status >= 400) {
          reject(new Error('VCO BOGO cart request failed'));
          return;
        }
        resolve(JSON.parse(request.responseText));
      };
      request.onerror = function () {
        reject(new Error('VCO BOGO cart request failed'));
      };
      request.send(body === undefined ? null : JSON.stringify(body));
    });
  }

  function pairItems(quantity) {
    return [
      {
        id: Number(TARGET_VARIANT),
        quantity: quantity,
        properties: { _vco_bogo_role: FREE_ROLE }
      },
      {
        id: Number(TARGET_VARIANT),
        quantity: quantity,
        properties: { _vco_bogo_role: PAID_ROLE }
      }
    ];
  }

  function replaceVcoLines(cart, pairQuantity) {
    var updates = {};
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === TARGET_VARIANT) updates[item.key] = 0;
    });

    var removeExisting = Object.keys(updates).length
      ? requestJson('POST', 'cart/update.js', { updates: updates })
      : Promise.resolve();

    return removeExisting.then(function () {
      return requestJson('POST', 'cart/add.js', { items: pairItems(pairQuantity) });
    });
  }

  function verifyVcoPair(pairQuantity, attempt) {
    attempt = attempt || 0;

    return requestJson('GET', 'cart.js').then(function (cart) {
      var paidQuantity = 0;
      var freeQuantity = 0;

      cart.items.forEach(function (item) {
        if (String(item.variant_id) !== TARGET_VARIANT) return;

        if (item.properties && item.properties._vco_bogo_role === FREE_ROLE) {
          freeQuantity += item.quantity;
        } else if (item.properties && item.properties._vco_bogo_role === PAID_ROLE) {
          paidQuantity += item.quantity;
        }
      });

      if (paidQuantity === pairQuantity && freeQuantity === pairQuantity) return cart;
      if (attempt >= 1) throw new Error('VCO BOGO pair verification failed');

      return replaceVcoLines(cart, pairQuantity).then(function () {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 250);
        });
      }).then(function () {
        return verifyVcoPair(pairQuantity, attempt + 1);
      });
    });
  }

  function normalizeExistingCart() {
    if (busy || window.__nariyalVcoRemovalPending) return;

    requestJson('GET', 'cart.js').then(function (cart) {
      var lines = cart.items.filter(function (item) {
        return String(item.variant_id) === TARGET_VARIANT;
      });
      if (!lines.length) return;

      var paid = lines.filter(function (item) {
        return item.properties && item.properties._vco_bogo_role === PAID_ROLE;
      });
      var free = lines.filter(function (item) {
        return item.properties && item.properties._vco_bogo_role === FREE_ROLE;
      });

      if (paid.length === 1 && free.length === 1 && paid[0].quantity === free[0].quantity) {
        return;
      }

      var totalQuantity = lines.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
      busy = true;
      return replaceVcoLines(cart, Math.max(1, Math.ceil(totalQuantity / 2))).then(function () {
        window.location.reload();
      });
    }).catch(function (error) {
      console.error('[Nariyal VCO BOGO]', error);
      busy = false;
    });
  }

  function showFreeBottleRow() {
    var selector = 'tr.line-item[data-variant-id="' + TARGET_VARIANT + '"]';
    if (document.querySelector(selector + '.line-item--vco-bogo-free')) return;

    document.querySelectorAll(selector).forEach(function (row) {
      if (row.classList.contains('line-item--vco-bogo-free')) return;
      var input = row.querySelector('.quantity-selector__input');
      if (!input || row.dataset.vcoSplitReady === 'true') return;

      row.dataset.vcoSplitReady = 'true';
      row.classList.add('line-item--vco-bogo-paid');
      input.value = '1';
      input.setAttribute('value', '1');

      var freeRow = row.cloneNode(true);
      freeRow.classList.remove('line-item--vco-bogo-paid');
      freeRow.classList.add('line-item--vco-bogo-free');
      freeRow.dataset.vcoSplitReady = 'true';
      freeRow.querySelectorAll('.line-item__quantity, .quantity-selector, .line-item__remove-button').forEach(function (node) {
        node.remove();
      });
      freeRow.querySelectorAll('.line-item__discount-list, .line-item__discount-badge, .discount-badge').forEach(function (node) {
        node.remove();
      });
      freeRow.querySelectorAll('.price-list').forEach(function (prices) {
        prices.innerHTML = '<span class="price price--highlight">Free!</span><span class="price price--compare">Rs. 594</span>';
      });
      row.parentNode.insertBefore(freeRow, row.nextSibling);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    var data = new FormData(form);
    if (String(data.get('id')) !== TARGET_VARIANT || busy) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    busy = true;

    var quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
    requestJson('GET', 'cart.js')
      .then(function (cart) { return replaceVcoLines(cart, quantity); })
      .then(function () { window.location.assign(rootUrl('cart')); })
      .catch(function (error) {
        console.error('[Nariyal VCO BOGO]', error);
        busy = false;
        form.submit();
      });
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '[data-nariyal-buy-now], [id^="BuyItNowTLPC-"], [id^="StickyBuyNowTLPC-"]'
    );
    if (!button || busy) return;

    var form = button.form || button.closest('form');
    if (!form) {
      var productRoot = button.closest('product-form, .shopify-section, .product');
      form = productRoot && productRoot.querySelector('form[action*="/cart/add"]');
    }
    if (!form) return;

    var data = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    var variantId = data.get('id') || (idInput && idInput.value);
    if (String(variantId) !== TARGET_VARIANT) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    busy = true;

    var quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    requestJson('GET', 'cart.js')
      .then(function (cart) { return replaceVcoLines(cart, quantity); })
      .then(function () { return verifyVcoPair(quantity); })
      .then(function () { window.location.assign(rootUrl('checkout')); })
      .catch(function (error) {
        console.error('[Nariyal VCO BOGO Buy Now]', error);
        busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      showFreeBottleRow();
    }, { once: true });
  } else {
    showFreeBottleRow();
  }
})();
